<div class=steps-container [ngClass]="prefixClass + '-container'">
    <ng-container *ngFor="let step of steps">
        <div class="step" [ngClass]="getStepClasses(step)">
            <h5 class="step__title" [ngClass]="getStepClasses(step)" >
                {{step.title}}
            </h5>
        </div>
    </ng-container>
</div>

<div class="steps-container-mobile">
  <ng-container *ngFor="let step of steps">
    <div class="step-mobile" [ngClass]="[getStepClasses(step), prefixClass]"></div>
  </ng-container>
</div>
